/* eslint-disable react-hooks/exhaustive-deps */
import {Box} from '@mui/material';
import React, {ReactNode} from 'react';
import {usePageSetting} from '~/providers/page-context.provider';
import EStoreProductDetailDownloadable from '@wearesection/bandai-react-components/organisms/EStoreProductDetailDownloadable';
import RenderNextLink from '../../atoms/render-next-link';

type IProps = {
  loading?: boolean;
  listProductDLC: any[];
  title: string;
};

const EStoreProductDetailDownloadableOrganisms: React.FC<IProps> = ({
  loading,
  listProductDLC,
  title,
}) => {
  const {globalData} = usePageSetting();
  const dataTranslation = globalData?.dataTranslation?.[0] ?? {};

  return (
    <Box
      sx={{
        background: '#F9F9F9',
      }}
    >
      {!loading && (
        <EStoreProductDetailDownloadable
          listItemDLC={{
            titleSeeMore: dataTranslation['nav-see-more'] || 'See more',
            nextLink: (href: string, child: ReactNode) => (
              <RenderNextLink href={`${href}`} child={child} />
            ),
            title:
              dataTranslation['estore-products-detail-title-dowloadable-dlc'] ||
              'Downloadable content (DLC)',
            titleSeeAll:
              dataTranslation['estore-products-detail-title-dowloadable-dlc-see-all'] ||
              'See all DLC',
            hrefSeeAll: `/store/games-dlc?tb=${title}`,
            listThumbnail: listProductDLC,
          }}
          titleModalSelectPlatform={
            dataTranslation['estore-products-detail-title-dowloadable-select-platform'] ||
            'Select your platform'
          }
          titleButtonBuyNowDigital={{
            ps:
              dataTranslation['estore-products-detail-title-button-buy-now-ps'] ||
              'Buy now at PS Store',
            stream:
              dataTranslation['estore-products-detail-title-button-buy-now-steam'] ||
              'Buy now at Steam',
            xbox:
              dataTranslation['estore-products-detail-title-button-buy-now-xbox'] ||
              'Buy now at Xbox.com',
            nintendo:
              dataTranslation['estore-products-detail-title-button-buy-now-nintendo'] ||
              'Buy now at Nintendo.com',
          }}
          onClickBuy={(value: any) => {
            if (typeof window !== 'undefined') {
              window.open(`/store/games/${value?.id}?platform=${value?.idPlatform}`);
            }
          }}
        />
      )}
    </Box>
  );
};

export default EStoreProductDetailDownloadableOrganisms;
